import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { resolverVisao } from '../lib/visao';

/** Bloqueia a rota quando o perfil não tem a permissão. O backend valida de novo. */
export function ExigePermissao({
  permissao,
  children,
}: {
  permissao: string;
  children: JSX.Element;
}): JSX.Element {
  const { pode } = useAuth();
  if (!pode(permissao)) return <Navigate to="/" replace />;
  return children;
}

/**
 * O colaborador (só com a própria escala) usa apenas "Minha escala". Qualquer outra tela
 * envolvida por isto o leva para lá, inclusive a inicial logo depois de entrar.
 */
export function ForaDoColaborador({ children }: { children: JSX.Element }): JSX.Element {
  const { pode } = useAuth();
  if (resolverVisao(pode).colaborador) return <Navigate to="/escala" replace />;
  return children;
}
